// extracted by mini-css-extract-plugin
module.exports = {"DescriptionWrapper":"description_DescriptionWrapper__1Co8X"};